import { ScreenType, useScreenType } from "@redotech/react-util/screen";
import { Flex } from "@redotech/redo-web/flex";
import { memo, ReactNode } from "react";

export const ShipmentMethodCard = memo(function ShippingMethodCard({
  icon,
  title,
  description,
  button,
}: {
  icon: ReactNode;
  title: ReactNode;
  description: ReactNode;
  button?: ReactNode;
}) {
  const size = useScreenType();

  return (
    <Flex
      align={size === ScreenType.MOBILE ? "flex-start" : "center"}
      bgColor="brand-primary"
      dir={size === ScreenType.MOBILE ? "column" : "row"}
      gap="xl"
      p="3xl"
      radius="lg"
    >
      {icon}
      <Flex dir="column" flex={1}>
        {title}
        {description}
      </Flex>
      {button}
    </Flex>
  );
});
